// A change of many records one by one (BulkEdit, R-U30): each record its own command; a refusal is told with its reason and does not
// stop the others; a record the change would not touch is counted apart, not as changed (MiniMax review wave A, P3-2).

export interface BulkOutcome { ok: number; same: number; failed: { id: string; reason: string }[] }
type Answer = { ok: true } | { ok: false; error: { message: string } };

/** A record the change cannot apply to, with the reason (e.g. «Выполнить» in a category without a «won» stage) — told, not skipped. */
export interface Refused { refuse: string }
const refused = (i: unknown): i is Refused => typeof i === 'object' && i !== null && typeof (i as Refused).refuse === 'string';

/** `input` — the command's input for the record, null when it has nothing to change, or a refusal; `send` runs it. */
export async function applyEach(ids: string[], input: (id: string) => unknown | null, send: (input: unknown) => Promise<Answer>, onStep?: (done: number) => void): Promise<BulkOutcome> {
  const out: BulkOutcome = { ok: 0, same: 0, failed: [] };
  for (const [n, id] of ids.entries()) {
    const i = input(id);
    if (i === null) out.same++;
    else if (refused(i)) out.failed.push({ id, reason: i.refuse });
    else {
      const r = await send(i);
      if (r.ok) out.ok++; else out.failed.push({ id, reason: r.error.message });
    }
    onStep?.(n + 1);
  }
  return out;
}
